module.exports = __webpack_public_path__ + "static/media/img-how-qr-code-works-03.144295c7.svg";